<div class="e-signature-layout">
  <nz-card>
    <div class="col align-items-center justify-content-center">
      <div class="row align-items-center justify-content-center w-60 mb-6">
        <div class="col align-items-center">
          <img src="assets/img/logo_dark.png" alt="Claro logo" class="logo" />
          <h1 class="text-center">CLARO</h1>
        </div>
        @if (mobileSigning) {
          <img src="assets/img/e-sign/eMobile.png" alt="eID Eparaksts logo" class="e-sign-logo" />
        }
        @if (!mobileSigning) {
          <img src="assets/img/e-sign/eparaksts_eID_Karte.png" alt="eID Eparaksts logo" class="e-sign-logo" />
        }
      </div>

      @if (loading && mobileSigning) {
        @if (step === Steps.INIT) {
          <div class="text-3xl text-center">Notiek faila sagatavošana parakstīšanai, lūdzu uzgaidiet</div>
        }
        @if (step === Steps.SIGN) {
          <div class="text-3xl text-center">Notiek parakstīšana, lūdzu uzgaidiet</div>
        }
      }
      @if (loading && !mobileSigning) {
        <div class="text-3xl text-center">Pārliecinies, ka esi ievietojis eID karti karšu lasītājā</div>
      }

      <div class="mt-3">
        @if (loading) {
          <nz-spin class="mt-3 mb-4"></nz-spin>
        }
        @if (!loading && errorMessages.length > 0) {
          <div class="col align-items-center justify-content-center">
            @for (errorMsg of errorMessages; track $index) {
              <div class="text-3xl text-center mb-3">
                @if (noPluginError || reloadError || otherError) {
                  <span class="text-danger">Kļūda:</span>
                  } {{ errorMsg }}
                </div>
              }
              @if (noPluginError) {
                <a href="https://www.eparaksts.lv/lv/no_plugin" target="_self" nz-button nzType="link"
                  >Uz lejupielādes lapu</a
                  >
                }
                @if (versionError) {
                  <a href="https://www.eparaksts.lv/atjauno_eParakstitajs3.0" target="_self" nz-button nzType="link"
                    >Uz lejupielādes lapu</a
                    >
                  }
                  <div class="row align-items-center justify-content-center gap-3 mt-2">
                    @if (reloadError) {
                      <button nz-button (onClick)="reloadPage()" nzSize="large" nzType="primary">Pārlādēt</button>
                    }
                    <button nz-button [routerLink]="returnRoute" nzSize="large" nzType="primary">Atpakaļ</button>
                  </div>
                </div>
              }
            </div>
          </div>
        </nz-card>
      </div>
